const pattern = /^([A-Za-z0-9_:$!%.-])+\@([A-Za-z0-9_.-])+\.([A-Za-z]{2,10})$/;


const testMail = (value) => pattern.test(value);

export {pattern};
export default testMail;